import { request } from '@umijs/max';

// 获取商户列表
export async function getShopListPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/shop/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取全部商户
export async function getShopListAll({ filter }: { filter: API.FormValues }) {
  return request('/api/admin/shop/all', {
    method: 'POST',
    data: {
      filter,
    },
  });
}

// 获取商户详情
export async function getShopListInfo(values: API.FormValues) {
  return request('/api/admin/shop/info', {
    method: 'POST',
    data: values,
  });
}

// 创建商户
export async function addShopList(values: API.FormValues) {
  return request('/api/admin/shop/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑商户
export async function editShopList(values: API.FormValues) {
  return request('/api/admin/shop/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除商户
export async function removeShopList(values: API.FormValues) {
  return request('/api/admin/shop/remove', {
    method: 'POST',
    data: values,
  });
}

// 批量导入商户
export async function importShopList(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request('/api/admin/shop/import', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
